import Edit16 from '@carbon/icons-react/es/edit/16';
import { useBoolean } from 'ahooks';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Menu } from 'components/atoms/dropdown/menu';
import { MoreActionsDropdown } from 'components/atoms/more-actions';
import { EmbedSpaceTabEditModal } from 'components/molecules/space-embed-edit-modal';
import { SpaceTab } from 'data/space-tabs';
import { updateDocumentTemplateAction } from 'data/templates/documents';
import { deleteProjectTemplateSpaceTab } from 'data/templates/projects';
import { useDeleteConfirmModal } from 'hooks/use-delete-confirm-modal';
import { useTranslation } from 'hooks/use-translation';

const menu = ({ onDeleteSpaceTab, onEditSpaceTab, canShowEdit }) => (
  <Menu>
    {canShowEdit ? (
      <>
        <Menu.Item key="edit" onClick={onEditSpaceTab} icon={<Edit16 />}>
          <FormattedMessage id="edit" />
        </Menu.Item>
        <Menu.Divider />
      </>
    ) : null}
    <Menu.ItemDelete key="delete" onClick={onDeleteSpaceTab} />
  </Menu>
);

export const DocumentTemplateMoreActions: FC<{
  className?: string;
  spaceId?: number;
  canShowEdit?: boolean;
  data: SpaceTab;
}> = ({ className, spaceId, canShowEdit, data }) => {
  const { spaceTabId, url: spaceTabUrl, spaceTabTitle } = data;
  const deleteTitle = useTranslation('space_tab.delete.confirm.title');
  const deleteConfirmationText = useTranslation(
    'space_tab.delete.confirm.message',
  );
  const dispatch = useDispatch();
  const DeleteConfirmation = useDeleteConfirmModal({
    title: deleteTitle,
    content: deleteConfirmationText,
    onOk: () => {
      dispatch(deleteProjectTemplateSpaceTab({ spaceTabId }));
    },
  });
  const [isModalVisible, { setTrue, setFalse }] = useBoolean(false);
  const handleOnFinish = async (values) => {
    const { spaceTabTitle: spaceTabTitleVal, url } = values;

    const template = {
      templateId: spaceTabId,
      templateName: spaceTabTitleVal,
    };

    dispatch(
      updateDocumentTemplateAction({
        template,
        spaceTab: {
          ...data,
          url,
        },
        spaceId,
      }),
    );
    setFalse();
  };

  const initialValues = {
    url: spaceTabUrl || '',
    spaceTabTitle: spaceTabTitle || '',
  };

  return (
    <>
      <MoreActionsDropdown
        className={className}
        menu={menu({
          onDeleteSpaceTab: DeleteConfirmation,
          onEditSpaceTab: setTrue,
          canShowEdit,
        })}
      />
      <EmbedSpaceTabEditModal
        initialValues={initialValues}
        onCancel={setFalse}
        isModalVisible={isModalVisible}
        onFinish={handleOnFinish}
      />
    </>
  );
};
